import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { decorAPI } from '../../utils/api';

export default function DecorQuote() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    full_name: '',
    phone: '',
    email: '',
    wedding_date: '',
    venue: '',
    guest_count: '100to300',
    budget: '3to5',
    style_preference: 'nepali',
    services_needed: '',
    description: ''
  });

  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    try {
      const res = await decorAPI.submitQuote(form);
      setMsg({ ok: true, text: res.message || 'Mandap Quote submitted! We will contact you within 24 hours.' });
      setForm({
        full_name: '', phone: '', email: '', wedding_date: '', venue: '',
        guest_count: '100to300', budget: '3to5', style_preference: 'nepali',
        services_needed: '', description: ''
      });
    } catch {
      setMsg({ ok: false, text: 'Could not submit quote. Please call Krishna Khanal at 9867155395.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sec-wrapper" style={{ maxWidth: '880px' }}>
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ SABITRI MANDAP DECOR & TENT HOUSE ✦
            </span>
          </div>

          <h1 className="hero-title">
            Request a Custom <span className="hero-title-gradient">Mandap Decor Quote</span>
          </h1>

          <p className="hero-subtitle">
            Crafting royal wedding mandaps, floral arches, marquee tents, and stage lighting. Managed by <strong>Krishna Khanal (9867155395)</strong> & <strong>Laxmikant Timilsina (9857074103)</strong>.
          </p>

          <div className="hero-cta-group">
            <a href="tel:9867155395" className="btn btn-secondary">
              📞 Call Krishna: 9867155395 →
            </a>
            <button className="btn btn-tertiary" onClick={() => navigate('/decor/catalog')}>
              View Mandap Catalog →
            </button>
          </div>
        </div>
      </section>

      {/* 3 Step Workflow */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '1.2rem',
        marginBottom: '2.5rem'
      }}>
        {[
          ['1', 'Share Your Vision', 'Fill event date, venue & style preference.'],
          ['2', 'Receive Custom Quote', 'Detailed decor & tent package within 24 hrs.'],
          ['3', 'Confirm & Celebrate', 'Pay deposit and relax while we design!']
        ].map(([step, title, desc]) => (
          <div key={step} className="card" style={{ textAlign: 'center' }}>
            <div style={{
              width: '36px', height: '36px', borderRadius: '50%',
              background: 'linear-gradient(135deg, #9E1B32, #7A1221)',
              color: '#fff', fontWeight: 800, fontSize: '0.9rem',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 0.6rem'
            }}>
              {step}
            </div>
            <h4 style={{ fontFamily: 'var(--serif)', fontSize: '1.1rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.3rem' }}>
              {title}
            </h4>
            <p style={{ fontSize: '0.82rem', color: '#6E615E', lineHeight: 1.5 }}>
              {desc}
            </p>
          </div>
        ))}
      </div>

      {/* Form Card */}
      <div className="card" style={{ border: '1.5px solid #D4AF37' }}>
        {msg && (
          <div style={{
            background: msg.ok ? '#e8f5e9' : '#FEECEC',
            color: msg.ok ? '#2e7d32' : '#9E1B32',
            border: msg.ok ? '1px solid #a5d6a7' : '1px solid rgba(158,27,50,0.3)',
            borderRadius: '14px', padding: '1rem 1.2rem', marginBottom: '1.5rem',
            fontSize: '0.88rem', fontWeight: 700
          }}>
            {msg.ok ? '✓ ' : '⚠️ '}{msg.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.8rem', borderBottom: '1px solid #E8DFD1', paddingBottom: '1.2rem' }}>
            <h3 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#9E1B32', marginBottom: '1rem', fontFamily: 'var(--serif)' }}>
              1. Personal Information
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.2rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Full Name *</label>
                <input type="text" className="form-input" value={form.full_name} onChange={handleChange('full_name')} placeholder="Your full name" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Phone Number *</label>
                <input type="tel" className="form-input" value={form.phone} onChange={handleChange('phone')} placeholder="98XXXXXXXX" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Email Address *</label>
                <input type="email" className="form-input" value={form.email} onChange={handleChange('email')} placeholder="you@email.com" required />
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '1.8rem', borderBottom: '1px solid #E8DFD1', paddingBottom: '1.2rem' }}>
            <h3 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#9E1B32', marginBottom: '1rem', fontFamily: 'var(--serif)' }}>
              2. Wedding & Decor Specifications
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.2rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Wedding Date *</label>
                <input type="date" className="form-input" value={form.wedding_date} onChange={handleChange('wedding_date')} required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Venue Location *</label>
                <input type="text" className="form-input" value={form.venue} onChange={handleChange('venue')} placeholder="Venue name or city" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Decor Style</label>
                <select className="form-input" value={form.style_preference} onChange={handleChange('style_preference')}>
                  <option value="nepali">Traditional Palpali Mandap</option>
                  <option value="royal">Royal Mughal Arch & Backdrop</option>
                  <option value="modern">Modern Minimalist Crystal</option>
                  <option value="garden">Fairy Light & Marquee Canopy</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Estimated Budget (NPR)</label>
                <select className="form-input" value={form.budget} onChange={handleChange('budget')}>
                  <option value="1to3">NPR 1 Lakh – 3 Lakhs</option>
                  <option value="3to5">NPR 3 Lakhs – 5 Lakhs</option>
                  <option value="5to10">NPR 5 Lakhs – 10 Lakhs</option>
                  <option value="above10">NPR 10 Lakhs +</option>
                </select>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '1.8rem' }}>
            <h3 style={{ fontSize: '1.35rem', fontWeight: 700, color: '#9E1B32', marginBottom: '1rem', fontFamily: 'var(--serif)' }}>
              3. Specific Decor Vision & Services Needed
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Services Needed *</label>
                <input type="text" className="form-input" value={form.services_needed} onChange={handleChange('services_needed')} placeholder="e.g. Mandap, Entrance Gate, Stage Backdrop, Fairy Lights..." required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Describe Your Theme / Vision</label>
                <textarea className="form-input" rows={3} value={form.description} onChange={handleChange('description')} placeholder="Color preferences, marigold/rose flower themes, special stage lighting..." />
              </div>
            </div>
          </div>

          <button className="btn btn-primary btn-full" type="submit" disabled={loading} style={{ padding: '0.9rem', fontSize: '1rem' }}>
            {loading ? '⏳ Submitting Mandap Quote…' : 'Request My Custom Decor Quote →'}
          </button>
        </form>
      </div>
    </div>
  );
}